// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import type Enums from '../Enums';

export class NotificationMessage {
  readonly id: string;
  readonly userId: string;
  readonly tenantId: string;
  readonly title: string;
  readonly message: string;
  readonly data: { [key: string]: string };
  readonly isRead: boolean;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;
  readonly recordType: Enums.ReminderSystemRecordType | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.userId = data.userId === undefined ? NIL_UUID : data.userId;
    this.tenantId = data.tenantId === undefined ? NIL_UUID : data.tenantId;
    this.title = data.title === undefined ? '' : data.title;
    this.message = data.message === undefined ? '' : data.message;
    this.data = data.data ?? {};
    this.isRead = data.isRead === undefined ? false : data.isRead;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
    this.recordType = data.recordType === undefined ? null : data.recordType;
  }

  static zero(): NotificationMessage {
    const zeroValues: ExcludeMethodsDeep<NotificationMessage> = {
      id: NIL_UUID,
      userId: NIL_UUID,
      tenantId: NIL_UUID,
      title: '',
      message: '',
      data: {},
      isRead: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      recordType: null,
    };
    return new NotificationMessage(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type NotificationMessageWireFormat = {
  id: string;
  userId: string;
  tenantId: string;
  title: string;
  message: string;
  data: { [key: string]: string };
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
  recordType: string | null;
};

type NewNotificationMessageProps = PartialDeep<NotificationMessage, { recurseIntoArrays: true }>;
export const NewNotificationMessage: (props: NewNotificationMessageProps) => NotificationMessage = (
  props,
) => new NotificationMessage(props);

type NewNotificationMessageFromWireFormatProps = PartialDeep<
  NotificationMessageWireFormat,
  { recurseIntoArrays: true }
>;
export const NewNotificationMessageFromWireFormat: (
  props: NewNotificationMessageFromWireFormatProps,
) => NotificationMessage = (props) => new NotificationMessage(props);
